import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { sunburst } from 'react-syntax-highlighter/styles/hljs';
import { translate, Interpolate } from 'react-i18next';

const example = `curl https://mise.se/TestAPI/api/ \\
  -H "Authorization: Basic TWlzZUFwaTpNaXNlQXBpIzIwMTgwNA=="`

const AuthenticationSection = (props) => (
  <section className="method row" id="authentication">
  <div className="method__text col-lg-6">
    <h2>{props.t('title')}</h2>
    <hr />
    <Interpolate i18nKey='description' useDangerouslySetInnerHTML={true} />

    <div className="callout callout--info">
      <h5>{props.t('infoBox.title')}</h5>
      <p> <Interpolate i18nKey='infoBox.description' useDangerouslySetInnerHTML={true} />
      <br />
      <code className="highlighter-rouge">Basic TWlzZUFwaTpNaXNlQXBpIzIwMTgwNA==</code></p>
    </div>
  </div>
  <div className="method__code col-lg-6">
    <small>{props.t('common:exampleRequest')}</small>
    <SyntaxHighlighter language='bash' style={sunburst}>
      { example }
    </SyntaxHighlighter>

    <p>{props.t('example.description')}</p>
  </div>
</section>
);

export default translate(['AuthenticationSection', 'common'])(AuthenticationSection);



// WEBPACK FOOTER //
// ./src/components/sections/AuthenticationSection.jsx